// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".product-card__controls{display:flex}.product-card__control-button{width:100%}.product-card__control-button--preorder.base-button{font-size:var(--1ezh9h8);white-space:nowrap;text-overflow:ellipsis;overflow:hidden}", ""]);
// Exports
module.exports = exports;
